module.exports = __webpack_public_path__ + "static/media/Group 95689 (1).31d25c2f.svg";